import { makeAutoObservable } from "mobx";
import { OptionsObject, SnackbarAction, SnackbarKey, SnackbarMessage } from "notistack";
import { JSONAPIDocument } from "json-api-serializer";
import React from "react";
import { Grid } from "@mui/material";

export interface NotifierParams {
	message: SnackbarMessage;
	options?: OptionsObject;
	action?: (closeSnackbar: (key?: SnackbarKey) => void) => SnackbarAction;
}

export class SnackbarStore {
	public notifier: NotifierParams = {
		message: "",
	};

	constructor() {
		makeAutoObservable(this);
	}

	private notify = (data: NotifierParams) => {
		this.notifier = data;
	};

	notifySuccess = (message: string) => {
		this.notify({
			message,
			options: {
				variant: "success",
			},
		});
	};

	notifyError = (message: string) => {
		this.notify({
			message,
			options: {
				variant: "error",
			},
		});
	};

	notifyInvalidForm = () => {
		this.notify({
			message: "Ошибка валидации формы, проверьте правильность введенных данных",
			options: {
				variant: "error",
				autoHideDuration: 5000,
			},
		});
	};

	notifyApiError = (error: { data: JSONAPIDocument }) => {
		if (!error || !error.data) {
			this.notify({
				message: "Произошла неизвестная ошибка",
				options: {
					variant: "error",
					autoHideDuration: 5000,
				},
			});
		} else {
			const errorMessages = error.data.errors?.map((x) => x.detail);
			this.notify({
				message: (
					<Grid container>
						{errorMessages?.map((message) => (
							<Grid item xs={12} key={message}>
								{message}
							</Grid>
						))}
					</Grid>
				),
				options: {
					variant: "error",
					autoHideDuration: 5000,
				},
			});
		}
	};
}

export const snackbarStore = new SnackbarStore();
